/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurPrestationsGlobalesGridDto } from './FcbFormateurPrestationsGlobalesGridDto';
import {
    FcbFormateurPrestationsGlobalesGridDtoFromJSON,
    FcbFormateurPrestationsGlobalesGridDtoFromJSONTyped,
    FcbFormateurPrestationsGlobalesGridDtoToJSON,
} from './FcbFormateurPrestationsGlobalesGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormateurPrestationsGlobalesGridDtoPaginatedResults
 */
export interface FcbFormateurPrestationsGlobalesGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurPrestationsGlobalesGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormateurPrestationsGlobalesGridDto>}
     * @memberof FcbFormateurPrestationsGlobalesGridDtoPaginatedResults
     */
    results?: Array<FcbFormateurPrestationsGlobalesGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormateurPrestationsGlobalesGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormateurPrestationsGlobalesGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormateurPrestationsGlobalesGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurPrestationsGlobalesGridDtoPaginatedResultsFromJSON(json: any): FcbFormateurPrestationsGlobalesGridDtoPaginatedResults {
    return FcbFormateurPrestationsGlobalesGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormateurPrestationsGlobalesGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurPrestationsGlobalesGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormateurPrestationsGlobalesGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormateurPrestationsGlobalesGridDtoPaginatedResultsToJSON(value?: FcbFormateurPrestationsGlobalesGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormateurPrestationsGlobalesGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

